<main class="auth-page min-vh-100 bg-white text-dark">
  <div class="row g-0 min-vh-100">
    <section class="col-lg-6 auth-brand-panel text-white p-4 p-lg-4 d-none d-lg-flex flex-column justify-content-between overflow-hidden position-relative bg-dark">
      <router-link to="/" class="auth-brand-mark d-inline-flex mb-3 align-self-start bg-white rounded-3 p-2" aria-label="Siyanda Platinum home">
        <span class="auth-brand-mark-img d-block" role="img" aria-label="Siyanda Bakgatla Platinum Mine"></span>
      </router-link>

      <div>
        <p class="text-uppercase text-warning fw-bold text-xxs mb-2">Single sign-on</p>
        <h1 class="h3 fw-bold mb-2">Connecting you to the Siyanda Platinum Platform.</h1>
        <p class="text-white-50 mb-0">
          Your secure sign-in is being confirmed.
        </p>
      </div>

      <div>
        <hr class="my-3" />
        <div class="row g-3">
          <div class="col-4">
            <span class="d-block text-uppercase text-white-50 text-xxs mb-1">Production</span>
            <span class="d-block fw-bold text-warning">Tracked daily</span>
          </div>
          <div class="col-4">
            <span class="d-block text-uppercase text-white-50 text-xxs mb-1">Safety</span>
            <span class="d-block fw-bold text-warning">Always on</span>
          </div>
          <div class="col-4">
            <span class="d-block text-uppercase text-white-50 text-xxs mb-1">Sustainability</span>
            <span class="d-block fw-bold text-warning">Community first</span>
          </div>
        </div>
      </div>
    </section>

    <section class="col-lg-6 bg-white text-dark d-flex align-items-center justify-content-center p-4 p-md-5">
      <div class="col-12 col-sm-10 col-md-8 col-lg-9 col-xl-7 text-center">
        <div class="spinner-border text-primary mb-3" role="status" aria-label="Signing you in"></div>
        <h2 class="h3 fw-bold mb-2">Signing you in</h2>
        <p class="text-secondary mb-0">
          Please wait while we complete your secure sign-in.
        </p>
      </div>
    </section>
  </div>
</main>
